module.exports = __webpack_public_path__ + "img/LUB00338.e2980366.png";